import { CommonTooltips } from "@mcleod/common";
import { ClickEvent, Component, TableRowDisplayEvent } from "@mcleod/components";
import { CurrencyUtil, DateRange, DisplayType, DisplayValue, ModelRow, Navigation, SortUtil, StringUtil, UrlUtil } from "@mcleod/core";
import { AutogenLayoutCarrierOfferList } from "./autogen/AutogenLayoutCarrierOfferList";

const STATUS_COUNTERED = "O";
const STATUS_EOFFER = "F";
const STATUS_PENDING = "P";
export class CarrierOfferList extends AutogenLayoutCarrierOfferList {
    private _carrierName: string = null;

    override onLoad() {
        this.panelOffersListContainer.rows[0].style.height = "100%"; // pretty nasty hack to make the vertical scroll bar behave

        const urlProp = UrlUtil.getPropsFromUrl(window.location.search);
        if (urlProp != null && urlProp.carrier_name != null) {
            this.carrierName = urlProp.carrier_name
        }
    }

    /** This is an event handler for the onRowDisplay event of tableOffers.  */
    tableOffersOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        tableRow.forEveryChildComponent(comp => {
            this.setTooltipContent(comp, tableRow.data);
        });
    }

    setTooltipContent(comp: Component, modelRow: ModelRow) {
        switch (comp.id) {
            case "labelOfferDate":
                return CommonTooltips.setTooltipContentLayout(comp, modelRow.get("entered_user_id"), "common/UserQuickInfo", { minWidth: 128, minHeight: 140 });
            case "labelOriginLocationName":
                return CommonTooltips.setTooltipContentLayout(comp, modelRow.get("origin.location_id"), "lme/dispatch/LocationQuickInfo", { minWidth: 128, minHeight: 140 });
            case "labelDestinationLocationName":
                return CommonTooltips.setTooltipContentLayout(comp, modelRow.get("destination.location_id"), "lme/dispatch/LocationQuickInfo", { minWidth: 128, minHeight: 140 });
            case "labelCarrierName":
                if (!modelRow.isNull("payee_id")) {
                    return CommonTooltips.setTooltipContentLayout(comp, modelRow.get("payee_id"), "lme/powerbroker/CarrierQuickInfo", { minWidth: 128, minHeight: 140 });
                }
            case "labelOrderTotalChg":
                return CommonTooltips.setTooltipContentTextboxes(comp, () => [
                    { caption: "Freight Charge", displayType: DisplayType.CURRENCY, text: CurrencyUtil.formatCurrency(modelRow.get("orders.freight_charge")) },
                    { caption: "Other Charges", displayType: DisplayType.CURRENCY, text: CurrencyUtil.formatCurrency(modelRow.get("orders.otherchargetotal")) }]
                );
        }
    }

    buttonViewInNewTabOnClick(event: ClickEvent) {
        const carrierName = this.sourceCarrierOfferList.searchRow.get("carrier_name", null);
        const path = `lme/powerbroker/CarrierOfferList${StringUtil.isEmptyString(carrierName) ? "" : UrlUtil.buildQueryString("carrier_name=" + carrierName)}`;
        Navigation.navigateTo(path, { newTab: true });
    }

    applyOfferStatusSort(){
        this.tableOffers.clearSort();
        this.tableOffers.allRows.sort((tra, trb) => {
            const a = tra.data;
            const b = trb.data;
            const aStatus = this.convertStatusToWeight(a.getString("status"));
            const bStatus = this.convertStatusToWeight(b.getString("status"));
            if (aStatus < bStatus) {
                return -1;
            } else if (aStatus > bStatus) {
                return 1;
            } else {
                return SortUtil.compareTwoValues(a.getDate("offer_date"), b.getDate("offer_date"), "desc", true);
            }
        });
        for (const row of this.tableOffers.allRows)
            this.tableOffers.displayRow(row);
    }

    convertStatusToWeight(status: string) {
        switch (status) {
            case STATUS_COUNTERED:
                return 0;
            case STATUS_EOFFER:
                return 1;
            case STATUS_PENDING:
                return 2;
            default:
                return 3;
        }
    }

    get carrierName(): string {
        return this._carrierName;
    }
    set carrierName(value: string) {
        this._carrierName = value;
        if (!StringUtil.isEmptyString(value)) {
            this.textboxCarrierName.text = value;
            this.sourceCarrierOfferList.searchRow.setValueAndLookupModelData("carrier_name", value, {"name": value});
            this.textboxCarrierName.displayData(this.sourceCarrierOfferList.searchRow, null, 0);
            const defaultDateRange = DateRange.parseDateRangeWithKeywords("t-30,t");
            this.textboxDateRange.text = DisplayValue.getDisplayValue(defaultDateRange, DisplayType.DATERANGE, this.textboxDateRange.format);
            this.sourceCarrierOfferList.searchRow.set("offer_date", defaultDateRange);
            this.sourceCarrierOfferList.executeValidatedSearch()
                .then(() => this.applyOfferStatusSort());
        }
    }
}
